function IdSvg(props) {
    return (
        <svg className={props.className} version="1.1" viewBox="0 0 24 24">
            <path d="M21,7c0-2.2-1.8-4-4-4h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c1.1,0,2,0.9,2,2v1.1c0,0.6,0.4,1,1,1s1-0.4,1-1V7z"/>
            <path d="M21,16c0-0.6-0.4-1-1-1s-1,0.4-1,1v1c0,1.1-0.9,2-2,2h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c2.2,0,4-1.8,4-4V16z"/>
            <path d="M3,17c0,2.2,1.8,4,4,4h1c0.6,0,1-0.4,1-1s-0.4-1-1-1H7c-1.1,0-2-0.9-2-2v-1c0-0.6-0.4-1-1-1s-1,0.4-1,1V17z"/>
            <path d="M8,3H7C4.8,3,3,4.8,3,7v1c0,0.6,0.4,1,1,1s1-0.4,1-1V7c0-1.1,0.9-2,2-2h1c0.6,0,1-0.4,1-1S8.6,3,8,3z"/>
            <path d="M15,9c0-1.7-1.3-3-3-3S9,7.3,9,9s1.3,3,3,3S15,10.7,15,9z M12,10c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S12.6,10,12,10z"/>
            <path d="M7.5,14.4l-0.4,1.3c-0.2,0.5,0.1,1.1,0.6,1.3c0.5,0.2,1.1-0.1,1.3-0.6L9.4,15c0.2-0.6,0.8-1,1.4-1h2.4c0.6,0,1.2,0.4,1.4,1   l0.4,1.3c0.1,0.4,0.5,0.7,0.9,0.7c0.1,0,0.2,0,0.3-0.1c0.5-0.2,0.8-0.7,0.6-1.3l-0.4-1.3C16,13,14.7,12,13.2,12H12h-1.2   C9.3,12,8,13,7.5,14.4z"/>
        </svg>
    )
}

export default IdSvg;